import React from "react";

const OrDivider = () => {
  return (
    <div className="or-divider">
      <span className="or-divider__line"></span>
      <span className="or-divider__text">or</span>
      <span className="or-divider__line"></span>
    </div>
  );
};

export default OrDivider;
